<!-- 2023 春节专题 -->
<template>
<div class="new-year-2023">
    <SimpleHead />
    
    <div class="wrap-container">
        <div class="top-banner"><img src="https://media4.imgyb.xyz/media/v1/image/f90b34111e4b3b42057c63ff09c9ff44.png" alt=""></div>
        <div class="middle-banner"><img src="https://media2.imgyb.xyz/media/v1/image/a70c12e294cfcea57cf9b738561e64d5.png" alt=""></div>
        <div class="notice-wrap">
            <div class="top-bg font-size-zone"><img src="https://media2.imgyb.xyz/media/v1/image/e768e3563419dd882426754f15c9e541.png" alt=""></div>
            <div class="top-title">
                <img class="pc" src="https://media2.imgyb.xyz/media/v1/image/4b3add57434e900526228371a63b0d8c.png" alt="">
                <img class="media" src="https://media2.imgyb.xyz/media/v1/image/746fbad0b1620b3a6d3ff6aa82751abc.png" alt="">
            </div>
            <div class="middle-container">
                <div class="middle">
                    <div class="start-title">
                        <div>欢喜过大年，万象更新又一年。约克论坛“过新年”征集活动开启啦！</div> 
                        <div>以 <span>#寻找年味儿#</span> 为主题，通过本专题页面发布图文/视频帖子，一起聊聊过年那些事儿~</div>
                    </div>
                    <div class="main-title">发帖方向，可参考以下主题：</div>
                    <div class="style-item">
                        <div class="main"><span>#新年习俗大赏</span><i class="el-icon-edit"></i> <a :href="'/publish/dining?subject=e015667d-f8a5-473b-84b8-30cd86a83352'|hostBuild('forum')" target="_blank">立即参与</a></div>
                        <div class="subf">祭灶神、扫房子、糖瓜粘…你的家乡有哪些特色过年习俗？快来分享，大家一起涨姿势</div>
                    </div>
                    <div class="style-item second">
                        <div class="main"><span>#过年的N种打开方式</span><i class="el-icon-edit"></i> <a :href="'/publish/dining?subject=e015667d-f8a5-473b-84b8-30cd86a83352'|hostBuild('forum')" target="_blank">立即参与</a></div>
                        <div class="subf">
                            <div>你家有哪些过年仪式感？准备年夜饭、包饺子、帖春联、封红包、拜大年… </div>
                            <div>分享照片聊一聊，速速show出你的新年打开方式～</div>
                        </div>
                    </div>
                    <div class="main-title media">奖项设置：</div>
                    <div class="prize-item first media">
                        <div class="lab">&#127982;</div>
                        <div class="flex-cont">
                            <div>优质奖，10名 </div>
                            <div>前3名，每人奖励 ¥200微信红包；第4-6名，每人奖励 ¥88微信红包；第7-10名，每人奖励 ¥20.23微信红包。 </div>
                            <div>评选方式：结合帖子内容的文字图片或视频质量，以及帖子的浏览量、回复量、点赞量，在精 选作品中选择10名获奖者。</div>
                        </div>
                    </div>
                    <div class="prize-item media" >
                        <div class="lab">&#127982;</div>
                        <div class="flex-cont">
                            <div>每日精选参与奖，不限量 </div>
                            <div>被设置为精华帖，有机会获得每日精选参与奖，可获得5-20元不等微信红包。</div>
                        </div>
                    </div>
                    <div class="more-details">
                       <!--
                        <a href="https://forum.yorkbbs.ca/detail/534582c7-ca76-4aae-8ec4-36d28279db75?topic=chat" target="_blank" >更多活动详情 <i class="el-icon-arrow-right"></i></a>
                        -->
                    </div>
                    <div class="rabbit"><img src="https://media2.imgyb.xyz/media/v1/image/72f4c7d5876842ae6bfa6b404e57a17d.png" alt=""></div>
                </div>
            </div>
            <div class="bottom-bg font-size-zone"><img src="https://media1.imgyb.xyz/media/v1/image/eef6729b45b4172f1f4befe121d4329f.png" alt=""></div>
            
        </div>
        <div class="tab">
            <div class="item" :class="{active:type==0}" @click="typeChange(0)">精选</div>
            <div class="item" :class="{active:type==1}" @click="typeChange(1)">点赞最多</div>
            <div class="item" :class="{active:type==2}" @click="typeChange(2)">最新发布 </div>
        </div>
        <div class="info-wrap">
            <div class="top-bg font-size-zone"><img src="https://media2.imgyb.xyz/media/v1/image/e768e3563419dd882426754f15c9e541.png" alt=""></div>
            <div class="middle-container">
                <div class="middle">
                    <div class="post-list" v-if="list.length>0">
                        <template v-for="(item,index) in list" >
                            <YorkbbsInfoflowItem v-if="item.app === 'crm_ad'" :data="item" :key="index"></YorkbbsInfoflowItem>
                            <ItemSubject v-else :data="item" :key="item.id" />
                        </template>

                        
                    </div>
                    <div class="loading-style" v-if="hasMore && listLoading " ><i class="el-icon-loading"></i> 加载中</div>
                    <div class="loading-style" v-if="!hasMore" >没有更多了</div>
                </div>
            </div>
            <div class="bottom-bg font-size-zone"><img src="https://media1.imgyb.xyz/media/v1/image/eef6729b45b4172f1f4befe121d4329f.png" alt=""></div>
        </div>
    </div>
    <CssFooter></CssFooter> 
    <div style="height:100px" class="white-space"></div>
    <div class="join-play">
        <div class="box">
            <a @click="postLink($event)" :href="'/publish/dining?subject=e015667d-f8a5-473b-84b8-30cd86a83352'|hostBuild('forum')" target="_blank"><div><i class="yk yk-cms_edit"></i></div> 参与话题</a>
            <!-- <a @click="postLink($event)" href="javascript:void(0)"><div><i class="yk yk-cms_edit"></i></div> 参与话题</a> -->
        </div>

    </div>
</div>
</template>
<script>
import SimpleHead from '@/components/widgets/simple-head.vue'
import { isScrollToPageBottom ,inflowAdvConvert} from '@/utils/utils';
import { throttle } from 'throttle-debounce';
import YorkbbsInfoflowItem from '@/components/item-infoflow.vue'
import ItemSubject from './item-subject.vue'
import CssFooter from '@/components/css-footer.vue'
export default {
    name:'NewYear2023',
    components:{SimpleHead,YorkbbsInfoflowItem,ItemSubject,CssFooter},
    data(){
        return {
            type:0,
            params:{   
                "offset": 1,
                "size": 10,
                //"sort": ["property_thumbUpTotal: DESC","property_updatedAt: DESC"],
                "sort":['property_top: DESC','property_commentedAt: DESC'],
                "subject": [
                    "e015667d-f8a5-473b-84b8-30cd86a83352"
                ],
                "options":{"elite":[1]},    
            },
            list:[],
            pageComplete:false,
            hasMore:true,
            listLoading:false,
        }
    },
    created(){
        this.getList();
    },
    mounted() {
        window.addEventListener('scroll', this.pageScroll);

        this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('scroll', this.pageScroll);
        });
    },
    methods:{
        typeChange(index){
            if( this.type == index) return false;
            delete this.params.options;
            if( index == 0 ){
                this.params.sort = ['property_top: DESC','property_commentedAt: DESC'];
                this.params['options'] = {"elite":[1]};
            }
            if( index ==1 ){
                this.params.sort = ['property_thumbUpTotal: DESC'];
            }
            if( index == 2 ){
                this.params.sort = ['property_commentedAt: DESC'];
            }
            this.type = index;
            this.params.offset = 1;
            this.hasMore = true;
            this.list = [];
            this.getList();
  
        },
        async getList(){
            this.listLoading = true;
            let result = await this.$axios.post('/bbs/v1/get/post/list/for/subject',this.params);
            this.pageComplete = true;
            this.listLoading = false;
            if( result.code == 0 ){
          
                if( this.params.offset == 1 ){
                    this.list = [];
                }
                var inflowAdv = inflowAdvConvert(result.data.items, 'topic', '3261');
                this.list = this.list.concat(inflowAdv);
                this.hasMore = this.params.offset < result.data.pageTotal;
            }
        },
        pageScroll: throttle(300, function () {
            if( isScrollToPageBottom() && this.pageComplete && this.hasMore && !this.listLoading ){
                this.params.offset ++;
                this.getList();
            }
             
            /* let banner = this.$refs['banner'].scrollHeight;
            let top = document.documentElement.scrollTop || document.body.scrollTop;
            if( top>banner-100){
                this.showFunc = true;
            }else{
                this.showFunc = false;
            } */
 
            /* const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            const offsetTop = this.$refs.tab.offsetTop;
            this.tabFixed = scrollTop >= offsetTop; */
        }),
        postLink(event){
            console.log(event);
            try{
                
                flutterForumPost.postMessage(JSON.stringify({
                    topicId:'9f6ada73-4a8c-457f-8bd9-b9eca97ee4b0',
                    subject:'e015667d-f8a5-473b-84b8-30cd86a83352',
                    name:'美食天地'
                }))
                event.preventDefault()
                return false;
            }catch(err){
                return true;
            }
            
        }
    }
}
</script>
<style lang="less" scoped>
.new-year-2023{
    background: linear-gradient(180deg,#fff5de, #fff5de); 
    padding-top: 60px;
    /deep/.top-head{background-color: rgba(194,43,38);}
    .font-size-zone{font-size: 0;}
    .wrap-container{width:800px;margin:0 auto;}
    .top-banner{margin-bottom: 20px;}
    .middle-banner{margin-bottom: 50px;}
    .notice-wrap{
        position: relative; margin-bottom: 30px;
        .top-title{
            position: absolute; left: 0; top: 0; right: 0; padding: 0 70px; transform: translateY(-50%);
            .pc{display: block;}
            .media{display: none;}
        }
        .middle-container{
            background: linear-gradient(180deg, #f5324c, #f8465c);
            padding: 0 15px;
        }
        .middle{
            position: relative;
            background: #fff; padding: 30px 48px 30px;
           
            .start-title{
                font-size: 18px; line-height: 30px;
                span{color: #ff5636; font-weight: bold;}
            }
            .main-title{
                margin-top: 15px;font-size: 18px; line-height: 28px; font-weight: bold;
            }
            .style-item{
                margin-top: 10px;
                .main{
                    display: flex; align-items: center;
                    margin-bottom: 5px; 
                    span{font-size: 18px; line-height: 26px; color: #ff5636; font-weight: bold; margin-right: 10px;}
                    i{font-size: 14px; color: #4a4a4a; margin-right: 3px;}
                    a{color: #4a4a4a; font-size: 14px; line-height: 20px; text-decoration: underline;
                        &:hover{color: #e43a3a;}
                    }
                }
                .subf{font-size: 16px; line-height: 28px; color: #4a4a4a;}
                &.second{margin-top: 15px;}
            }
            .prize-item{
                display: flex; line-height: 28px;
                &.first{margin-top: 10px;}
                .flex-cont{flex:1; overflow: hidden; font-size: 16px; line-height: 28px; color: #4a4a4a;}

            }
            .more-details{
                display: flex; margin-top: 50px;
                a{
                    font-size: 14px; padding: 0 20px;
                    display: flex; align-items: center; height: 34px;
                    background:  linear-gradient(180deg,#ff344d, #e42b06);
                    border-radius: 20px; color: #fff;

                    &:hover{opacity: 0.8;}
                }
            }
            .rabbit{
                position: absolute; z-index: 2; right: 0; bottom: -26px;
                img{height: 118px;}
            }
        }
        

    }
    .info-wrap{
        .middle-container{
            background: linear-gradient(180deg, #f5324c, #f8465c);
            padding: 0 15px;
        }
        .middle{
            overflow: hidden;
            position: relative;
            background: #fff; 
            padding: 0 20px;
           
        }
    }
    .tab{
        display: flex; justify-content: center; align-items: center; margin-bottom: 20px;
        .item{
            user-select: none; cursor: pointer; 
            margin:0 25px;
            font-size: 16px; line-height: 24px; color: #F8465C;
            &.active{font-size: 24px; line-height: 36px; font-weight: 700;}
        }
    }
    .join-play{
        position: fixed; z-index: 10; bottom: 150px;  right: 10px;
        .box{
            display: flex; flex-direction: column; align-items: center; justify-content: center; color: #F25029; font-size: 20px; 
            background: #ffdc00;

            width:76px; height: 76px; user-select: none; cursor: pointer;
            font-size: 12px; color: #111; text-align: center;
            border-radius: 50%;
            i{font-size: 18px; margin-bottom: 10px;}
            &:hover{
                background: #f6354e; color: #fff;
            }
        }
    }
    .loading-style{display: flex; padding-bottom: 20px; color: #999; justify-content: center ; align-items: center; font-size: 12px;
        i{margin-right: 5px;}
    }
    .white-space{display: none;}
}

@media screen and (max-width:768px){
    .new-year-2023{
        padding-top: 55px;
        .wrap-container{
            width: 100%; box-sizing: border-box; padding: 0 15px;
        }
        .top-banner{margin-bottom: 15px;}
        .middle-banner{margin-bottom: 30px;}
        .notice-wrap{
            .top-title{
                padding:0 30px;
                .pc{display: none;}
                .media{display: block;}
            }
            .middle-container{padding:0  6px;}
            .middle{
                border-left-width: 6px; border-right-width: 6px;
                padding: 20px 15px 30px;
                .main-title{font-size: 16px;}

                .main-title.media{display: none;}
                .prize-item.media{display: none;}
                .start-title{font-size: 16px; line-height: 28px;}
                .style-item{
                    .main{
                        span{font-size: 16px;}
                    }
                    .subf{line-height: 24px;}
                }
                .rabbit{
                    bottom: -15px;
                    img{height: 60px; }
                }
            }
        }
        .info-wrap{
            .middle-container{
            
                padding: 0 6px;
            }
            .middle{border-left-width: 6px; border-right-width: 6px;}
        }
        .tab{
        
            .item{
                user-select: none; cursor: pointer; 
                margin:0 20px;
                font-size: 16px; line-height: 24px; color: #F8465C;
                &.active{font-size: 20px; line-height: 30px; font-weight: 700;}
            }
        }
    }
    
}
</style>